import { csvUtils } from "../../../utils";
const { makeCSV , parseCSV  } = csvUtils;
export function truncateSelectedValues(matchingValuesToDisplay, length = 4, conjunction = "or") {
    if (matchingValuesToDisplay.length <= 1) {
        return makeCSV(matchingValuesToDisplay);
    }
    const indexToSplitAt = Math.min(matchingValuesToDisplay.length - 1, length);
    const firstPart = matchingValuesToDisplay.slice(0, indexToSplitAt);
    const lastPart = matchingValuesToDisplay.slice(indexToSplitAt);
    const showPlusStyleEnding = matchingValuesToDisplay.length > length;
    const lastPartFormatted = showPlusStyleEnding ? ` +\u00A0${lastPart.length}\u00A0more` : ` ${conjunction} ${lastPart[0]}`;
    return makeCSV(firstPart, ", ") + lastPartFormatted;
}
export function stringifyReferenceDataValue(numberTypeReferenceData) {
    return numberTypeReferenceData.map((option)=>({
            value: option.value.toString(),
            label: option.label
        }));
}
export function findSelectedOptionLabel(referenceData, selectedValue = "") {
    var ref;
    return ((ref = referenceData.find((data)=>data.value === selectedValue)) === null || ref === void 0 ? void 0 : ref.label) ?? selectedValue;
}
export function formatSelectionsArray(selections, options) {
    return selections.map((selectedValue)=>findSelectedOptionLabel(options, selectedValue));
}
export function formatSelections(selections, options) {
    return parseCSV(selections).map((selectedValue)=>findSelectedOptionLabel(options, selectedValue));
}
